// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var Download = React.forwardRef(function Download(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Download" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0446 4C15.3649 4 18.8333 6.5 18 10.5C20.2553 10.8942 22 12.6472 22 15C22 17.637 19.8474 20 17.1921 20C17.1307 20 17.0695 19.9989 17.0086 19.9966H7.59462C7.5301 19.9989 7.46529 20 7.4002 20C4.41775 20 2 17.9618 2 15C2 12.499 3 10.5 6 9.5C5.5 6 8.90377 4 12.0446 4ZM10.5 12.5H7.5L12 17.5L16.5 12.5H13.5V8.5H10.5V12.5Z", fill: "currentColor" }))));
});
Download.displayName = 'Download';
export default Download;
//# sourceMappingURL=Download.js.map